import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_GET_FILTERS } from './url-constants';

type ManageAlarmsFilterDetailsEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsFilterDetailsEndpointSpecification: ManageAlarmsFilterDetailsEndpointSpecification = {
    url: MANAGE_ALARM_GET_FILTERS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageAlarmsFilterDetailsRequestParams',
    requestBodySchemaName: 'ManageAlarmsFilterDetailsRequestBody',
    okResponseSchemaName: 'ManageAlarmsFilterDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmFilterDetails = Helpers.makeApiRequestFn<
    Types.ManageAlarmsFilterDetailsRequestParams,
    Types.ManageAlarmsFilterDetailsRequestBody,
    Types.ManageAlarmsFilterDetailsOkResponse
>(ManageAlarmsFilterDetailsEndpointSpecification);
